export default function getDomain(req) {
  const host = req ? req.headers['x-forwarded-host'] || req.headers.host : window.location.host;
  return new URL(`https://${host}`).origin;
}
